var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_33637",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_33637)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 12.8C14.8401 12.8 17.1426 10.651 17.1426 8.00001C17.1426 5.34905 14.8401 3.20001 11.9998 3.20001C9.15947 3.20001 6.85693 5.34905 6.85693 8.00001C6.85693 10.651 9.15947 12.8 11.9998 12.8Z",
    fill: "url(#paint0_linear_239_33637)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_33637",
    x1: 6.85693,
    y1: 3.20001,
    x2: 6.85693,
    y2: 12.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB0831"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJp);
export default __webpack_public_path__ + "static/media/JP.96263a254e3b4cab34239b332100c394.svg";
export { ForwardRef as ReactComponent };